// Matches the palettes in index.css so Clerk's prebuilt components
// (SignIn/SignUp/UserProfile/OrganizationProfile) don't look like a
// different product bolted onto this one in either theme. @clerk/themes'
// `dark` base theme would normally handle this, but its 2.4.57 publish ships
// a package.json pointing at a dist/index.cjs that isn't actually in the
// tarball, so this is built entirely from variables instead of that preset.
const PALETTES = {
  dark: {
    colorPrimary: '#f52f55',
    colorBackground: '#141824',
    colorForeground: '#dde1f0',
    colorInput: '#1a1f2e',
    colorInputForeground: '#dde1f0',
    colorMutedForeground: '#7a82a0',
    colorMuted: '#1a1f2e',
    colorBorder: '#252d42',
    colorDanger: '#ef4444',
    colorSuccess: '#22c98a',
    colorWarning: '#f59e0b',
    colorNeutral: '#7a82a0',
    colorShadow: 'rgba(0,0,0,.4)',
  },
  light: {
    colorPrimary: '#c81440',
    colorBackground: '#ffffff',
    colorForeground: '#14172a',
    colorInput: '#eef1f8',
    colorInputForeground: '#14172a',
    colorMutedForeground: '#5a6079',
    colorMuted: '#eef1f8',
    colorBorder: '#d5dae8',
    colorDanger: '#dc2626',
    colorSuccess: '#0f9d6e',
    colorWarning: '#b45f04',
    colorNeutral: '#5a6079',
    colorShadow: 'rgba(20,23,42,.12)',
  },
};

export function getClerkAppearance(theme) {
  return {
    variables: {
      ...PALETTES[theme] || PALETTES.dark,
      borderRadius: '0.5rem',
      fontFamily: "'DM Sans', sans-serif",
    },
  };
}
